import { model } from "model";
import { Spinner } from "reactstrap";
import { AuditTally } from './AuditTally'
export const ManageAuditTally = () => {
    const { activeAuditLoaded } = model.useAuditCtx();
    return activeAuditLoaded ? <AuditTally /> : <Spinner />;
}